const CHECKBOX_TYPE = 'CheckboxField';
const RADIO_TYPE = 'RadioField';
const TEXT_TYPE = 'TextField';
const DROPDOWN_TYPE = 'DropdownField';

const FIELD_TYPE_LABELS = {
  [CHECKBOX_TYPE]: '(Checkbox Field)',
  [RADIO_TYPE]: '(Radio Buttons)',
  [TEXT_TYPE]: '(Text Field)',
  [DROPDOWN_TYPE]: '(Dropdown Field)'
};

const FIELD_PREVIEW_TEXT = {
  [TEXT_TYPE]: 'Your text here',
  [DROPDOWN_TYPE]: 'Select an option'
};

const REQUIRES_COLLECTION = [RADIO_TYPE, DROPDOWN_TYPE];

export {
  FIELD_TYPE_LABELS,
  FIELD_PREVIEW_TEXT,
  CHECKBOX_TYPE,
  RADIO_TYPE,
  TEXT_TYPE,
  DROPDOWN_TYPE,
  REQUIRES_COLLECTION
};